import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import { PlanType, planFromString } from './plan';

// users/{uid}.plan をリアルタイム購読してプランを返すフック（S-051-1h）。
//
// - 取得前は loading=true。読み取れたら plan を反映する。
// - ドキュメント未存在・フィールド欠損・読取エラーはいずれも free に倒す（安全側）。
//   （課金されていないユーザーが AI 機能を使えてしまう事故を防ぐ）
export interface PlanState {
  plan: PlanType;
  loading: boolean;
}

export function usePlan(uid: string | null | undefined): PlanState {
  const [plan, setPlan] = useState<PlanType>('free');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!uid) {
      setPlan('free');
      setLoading(false);
      return;
    }
    setLoading(true);
    const ref = doc(db, 'users', uid);
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        const raw = snap.exists() ? (snap.data().plan as string | undefined) : undefined;
        setPlan(planFromString(raw));
        setLoading(false);
      },
      (e: any) => {
        console.error('[usePlan] failed to read plan, falling back to free:', e);
        setPlan('free');
        setLoading(false);
      }
    );
    return unsubscribe;
  }, [uid]);

  return { plan, loading };
}
